import { UNIT_CO2_UNKNOWN } from '@/lib/constants';
import { Co2Emission } from '@/lib/models/emissions/types';

/**
 * Sums the total emissions from the array provided
 */
export const sumTotalCo2Emissions = (emissions: Co2Emission[]): Co2Emission => {
  if (emissions.length === 1) return emissions[0];

  return emissions.reduce(
    (accum, currentEmission) => {
      if (currentEmission) {
        return {
          wtw: accum.wtw + currentEmission.wtw,
          wtt: (accum.wtt || 0) + (currentEmission.wtt || 0),
          ttw: (accum.ttw || 0) + (currentEmission.ttw || 0),
          unit: currentEmission.unit,
        };
      }
      return accum;
    },
    {
      wtw: 0,
      wtt: 0,
      ttw: 0,
      unit: UNIT_CO2_UNKNOWN,
    },
  );
};
